/* eslint-disable implicit-arrow-linebreak */
import { useQuery } from '@tanstack/react-query';
import BenefitsService from 'src/services/benefits.service';

export const useEmployeeBenefits = (
  personnelNumber: string,
  params: {
    page: number;
    limit: number;
    sortBy: string;
    sortDirection: string;
    search: string;
    companyId: string;
    activeBenefits: boolean;
  }
) => {
  const result = useQuery({
    queryKey: ['employee/benefits'],
    queryFn: () =>
      BenefitsService.getBenefitsByEmployee(personnelNumber, {
        ...params,
      }),
    enabled: true,
  });
  return result;
};
